import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const RouteFocusHandler = () => {
  const location = useLocation();
  const previousRouteRef = useRef(
    `${location.pathname}${location.search}${location.hash}`
  );

  useEffect(() => {
    const currentRoute = `${location.pathname}${location.search}${location.hash}`;

    if (previousRouteRef.current !== currentRoute) {
      const main = document.getElementById("main-content");

      if (main) {
        requestAnimationFrame(() => {
          main.focus({ preventScroll: true });
          main.scrollIntoView({
            behavior: "auto",
            block: "start",
          });
        });
      }
    }

    previousRouteRef.current = currentRoute;
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default RouteFocusHandler;